
import { Vue, Component, Prop, PropSync } from "vue-property-decorator";
import { Company, Contractor, User } from "@/generated/graphql";
import CompanyContractorAdminCard from "@/components/companyContractors/CompanyContractorAdminCard.vue";
import Roles from "@/entities/Roles";
import CompanyContractorManagerCard from "@/components/companyContractors/CompanyContractorManagerCardNew.vue";
import ResourcesListCard from "@/components/companyContractors/ResourcesListCard.vue";

@Component({
  components: {
    CompanyContractorManagerCard,
    CompanyContractorAdminCard,
    ResourcesListCard,
  },
  
})
export default class CompanyContractorsCollectionCard extends Vue {
  @Prop({ type: Object, required: true }) readonly contractor!: Contractor;
  @Prop({ type: Object, required: true }) readonly ratingTotal!: Contractor;
  @Prop({ type: Object, required: true }) readonly company!: Company;
  @Prop({ type: Object, required: true }) readonly currentUser!: User;
  @Prop({ type: String, required: true }) readonly userUpdatedDate!: string;
  @Prop({ type: Boolean, required: true }) readonly hasAllResourceAccess: boolean;
  @Prop({ type: Boolean, default: false }) readonly managerDatabase!: boolean;
  @PropSync("nameBlockMinHeight", { type: Number, default: undefined })
  nameBlockMinHeightValue?: number;
  @PropSync("skillsBlockMinHeight", { type: Number, default: undefined })
  skillsBlockMinHeightValue?: number;
  @PropSync("managersBlockMinHeight", { type: Number, default: undefined })
  managersBlockMinHeightValue?: number;

  get isAdmin(): boolean {
    return this.currentUser.role === Roles.ADMIN;
  }
}
